import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Detail, MovableCardWrapper } from '../../styles/Base'
import EllipsisTooltip from './../../../../../../common/EllipsisTooltip'
import PlaybookActivityCard from '../../../cards/PlaybookActivityCard'
class Card extends Component {
  removeActivity = e => {
    const { id, laneId, removeCard, onDelete } = this.props
    removeCard(laneId, id)
  }

  renderBody = () => {
    if (this.props.customCardLayout) {
      const { customCard, ...otherProps } = this.props
      return React.cloneElement(customCard, { ...otherProps })
    } else {
      const { title } = this.props
      return (
        <span>
          <Detail >
            <EllipsisTooltip name={title} line={2} />
          </Detail>
        </span>
      )
    }
  }

  stoPropogation = (e) => {
    e.stopPropagation();
  }
  handleMilestoneClick = (e) => {

    e.stopPropagation()
    e.preventDefault()
  }

  getMapping(id) {
    if (this.props.communities)
      for (let i = 0; i < this.props.communities.length; i++) {
        let community = this.props.communities[i];
        if (id === community._id) {
          return community.name;
        }
        if (community.communities) {
          for (let j = 0; j < community.communities.length; j++) {
            let subCommunity = community.communities[j];
            if (id === subCommunity._id) {
              return community.name + " > " + subCommunity.name;
            }
          }
        }

      }
  }
  render() {
    const { id, cardStyle, editable, hideCardDeleteIcon, customCardLayout, dragStyle, isMilestone, duration, hideCardLinkIcon, enableLinkActivity, selectedActivity, _id, ...otherProps } = this.props
    const style = customCardLayout ? { ...cardStyle, padding: 0 } : cardStyle;

    return (
      <MovableCardWrapper
        key={id}
        data-id={id}
        style={{
          ...style,
          ...dragStyle
        }}
        {...otherProps}
        title=""
      >

        <PlaybookActivityCard
          type="activity"
          page="sequence"
          activityData={this.props.cardDetail}
          selectedPracticeLibrary={this.props.selectedPracticeLibrary}
          selectedActivity={this.props.selectedActivity}
          enableLinkActivity={this.props.enableLinkActivity}
          // removeActivity={this.removeActivity}
          communities={this.props.communities}
          removeEdge={this.props.removeEdge}
          _id={_id}
          editable={editable}
          hideCardDeleteIcon={hideCardDeleteIcon}
          user={this.props.user}
          currentOrganization={this.props.currentOrganization}
        />

      </MovableCardWrapper>
    )
  }
}
Card.defaultProps = {
  cardStyle: {},
  customCardLayout: false,
  onDelete: () => { },
  editable: false,
  dragStyle: {}
}

Card.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  index: PropTypes.number,
  description: PropTypes.string,
  label: PropTypes.string,
  tags: PropTypes.array,
  boardId: PropTypes.string.isRequired,
  laneId: PropTypes.string.isRequired,
  removeCard: PropTypes.func,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  metadata: PropTypes.object,
  cardStyle: PropTypes.object,
  dragStyle: PropTypes.object,
  tagStyle: PropTypes.object,
  customCardLayout: PropTypes.bool,
  customCard: PropTypes.node,
  editable: PropTypes.bool
}

export default Card
